import styled, { css } from 'styled-components';


export const BaseButton = styled.button`
    width: 175px;
    height: 66px;        
    border-radius: 33px;
    box-shadow: 0 2px 4px 0 rgba(198, 194, 194, 0.5);
    border: solid 1px #d7d7d7;
    background-color: #002b37;
    font-size: 20px;
    font-weight: 800;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #ffffff;
    font-family: 'Gilory-Bold';   
    cursor: pointer; 
    ${props => props.marginRight && css``}
`;

export const BaseButton2 = styled.button`
    width: 175px;
    height: 66px;        
    border-radius: 33px;
    box-shadow: 0 2px 4px 0 rgba(198, 194, 194, 0.5);
    border: solid 1px #d7d7d7;
    font-size: 20px;
    font-weight: 800;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    font-family: 'Gilory-Bold';   
    cursor: pointer; 
`;

export const BottomButton = styled.button`
    width: 175px;
    height: 66px;    
    border-radius: 33px;
    box-shadow: 0 2px 4px 0 rgba(198, 194, 194, 0.5);
    border: solid 1px #d7d7d7;
    font-family: 'Gilory-Bold';
    font-size: 20px;
    font-weight: 800;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    margin:0;
`;

export const BottomButtonAction = styled.button`
    width: 175px;
    height: 66px;    
    border-radius: 33px;
    box-shadow: 0 2px 4px 0 rgba(198, 194, 194, 0.5);
    border: solid 1px #d7d7d7;
    font-family: 'Gilory-Bold';
    font-size: 20px;
    font-weight: 800;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    cursor: pointer;
`;

export const FeedbackButtonConfirmation = styled.button`
    width: 100px;
    height: 66px;    
    border-radius: 33px;
    box-shadow: 0 2px 4px 0 rgba(198, 194, 194, 0.5);
    border: solid 1px #d7d7d7;
    font-family: 'Gilory-Bold';
    font-size: 20px;
    font-weight: 800;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    cursor: pointer;
`;

export const BanButton = styled(BottomButton)`
  width: 100px;
  margin-left  :30px;
`;


export const FeedProfileSelected = styled.button`
  width: 55px;
  height: 55px;
  margin: 35px 24px 47px 27px;
  border-radius: 27.5px;
  border: solid 5px #484848;
  ${props => props.selected && css`
    background-color:#484848;
  `}
  font-family: Gilroy;
  font-size: 20px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
`;

export const FeedGenederSelected = styled.button`
  width: 35px;
  height: 35px;
  margin: 55px 53px 35px 36px;
  border-radius: 27.5px;
  background-color:#ec4655;
  ${props => props.male && css`
    background-color:#50b3c5;
  `}  
  margin-top:30px;
  margin-bottom:30px;  
`;

